// src/cn.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
var cn = (...inputs) => {
  return twMerge(clsx(inputs));
};

export {
  cn
};
//# sourceMappingURL=chunk-RHUPFALB.js.map